import {
  MDBBtn,
  MDBCheckbox,
  MDBDatatable,
  MDBIcon,
  MDBInputGroup,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  editHuntGroup,
  editUserExternGroup,
  getMisc,
  getSupervisorData,
} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import { useFieldArray, useForm } from "react-hook-form";
import SaveChanges from "../../topviews/saveCancel";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import ToggleEditWarning from "./ToggleEditWarning";
import PopupLoader from "../../../views/popups/PopupLoader";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
function HuntSupervisorBody({ isActive, code, supervisorFlag, setEdited }) {
  const { t, i18n } = useTranslation();
  //   const [basicModal, setBasicModal] = useState(false);
  //   const toggleShow = () => setBasicModal(!basicModal);
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [supervisorList, setsupervisorList] = useState([]);
  const [reRender, setReRender] = useState(false);
  const [recordPermissions, setrecordPermissions] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [addUsers, setAddUsers] = useState(false);
  const addTogglePopup = () => setAddUsers(!addUsers);
  const [isLoading, setisLoading] = useState(false);
  const addUserRef = useRef(null);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [isdelete, setIsDelete] = useState(false);
  const dtogglePopup = () => setIsDelete(!isdelete);
  const [isdeleteUser, setIsDeleteUser] = useState(false);
  // const [callMonitorList, setcallMonitorList] = useState([]);
  // const [dynamicRecordingList, setdynamicRecordingList] = useState([]);
  // const [recordListenningOne, setrecordListenningOne] = useState([]);
  // const [recordListenningTwo, setrecordListenningTwo] = useState([]);
  // const [recordListenningThree, setrecordListenningThree] = useState([]);

  function handleClick() {
    addUserRef.current.click();
  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { dirtyFields, errors, isDirty },
    watch,
    reset,
    clearErrors,
    control,
    setError,
  } = useForm({
    defaultValues: {
      update_supervisors: [],
    },
  });

  const { fields } = useFieldArray({
    name: "update_supervisors",
    control,
  });

  const [editWarning, seteditWarning] = useState(false);
  const warningToggle = () => seteditWarning(!editWarning);
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [toggleValue, settoggleValue] = useState(-1);
  // const [uniqueKeyValue, setuniqueKeyValue] = useState("");
  const [columnName, setcolumnName] = useState("");
  const [selectedCallMonitor, setSelectedCallMonitor] = useState(false);
  const [selectedRecording, setselectedRecording] = useState(false);
  const [selectDropDown, setselectDropDown] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
   useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded, searchRef, isActive);
  const [searchValue, setSearchValue] = useState(""); // Add search value state
  const [filteredIndices, setFilteredIndices] = useState([]);

  useEffect(() => {
    setSearchValue(""); 
    if (fields && Array.isArray(fields) && fields.length > 0) {
      setFilteredIndices(fields.map((_, index) => index));
    } else {
      setFilteredIndices([]);
    }
  }, [fields.length]);


  useEffect(() => {
    async function fetchData() {
      let UserList = [],
        apiResponse = {};
      apiResponse = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["supervisors"], code: code }
      );
      if (apiResponse.status === 200) {
        UserList = await apiResponse.json();

        UserList = UserList.misc.supervisors;
        console.log("users list are :::::::::: " + JSON.stringify(UserList));
        // alert(JSON.stringify(UserList));
        setSourceUsers(UserList);
      } else {
      }
    }

    if ((code, isActive)) {
      fetchData();
    }
  }, [code, isActive]);

  async function fetchRecordPermision() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["recording_permissions"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    console.log("fetchRecordPermision :::::::::: " + JSON.stringify(tdata));
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    setrecordPermissions(tdata?.misc?.recording_permissions ?? []);
  }

  useEffect(() => {
    if (isActive) {
      fetchRecordPermision();
    }
  }, [isActive]);

  useEffect(() => {
    if ((isActive && supervisorFlag && code) || reRender) {
      fetchSupervisorData();
    }
  }, [isActive, supervisorFlag, code, reRender]);

  async function fetchSupervisorData() {
    try {
      setIsloading(true);
      const response = await getSupervisorData(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        code,
        supervisorFlag
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const rawData = await response.json();
      if (!rawData) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      console.log("response data is :::::::::: " + JSON.stringify(rawData));

      const superList =
        supervisorFlag === 1
          ? rawData?.supervisors?.part ?? []
          : supervisorFlag === 2
            ? rawData?.supervisors?.notpart ?? []
            : rawData?.supervisors?.all ?? [];
      setsupervisorList(superList);
      // const moniter = superList.filter((sup) => sup.callmonitor).map((sup) => sup.uniqueid)
      // setcallMonitorList(moniter);
      // const dynamic = superList.filter((sup) => sup.dynamicRecording).map((sup) => sup.uniqueid)
      // setdynamicRecordingList(dynamic);
      // const listenOne = superList.filter((sup) => sup.privilage === 0).map((sup) => sup.privilage)
      // const listenTwo = superList.filter((sup) => sup.privilage === 1).map((sup) => sup.privilage)
      // const listenThree = superList.filter((sup) => sup.privilage === 2).map((sup) => sup.privilage)
      // setrecordListenningOne(listenOne);
      // setrecordListenningTwo(listenTwo);
      // setrecordListenningThree(listenThree);

      setSelectedCallMonitor(false);
      setselectedRecording(false);
      setselectDropDown("");

      reset({ update_supervisors: superList });
      setReRender(false);
      setDataLoaded(true);
    } catch (error) { }
  }

  function handleCloseWarning() {
    if (updateFieldName.indexOf("monitor") !== -1) setSelectedCallMonitor("-1");
    else if (updateFieldName.indexOf("Recording") !== -1)
      setselectedRecording("-1");
    else setselectDropDown("");

    warningToggle();
  }

  // function handleAllChange(feildName, columnName, value) {
  //   if (value !== "-1") {
  //     setupdateFieldName(feildName);
  //     setupdateFieldValue(value);
  //     seteditWarning(true);
  //     // setuniqueKeyValue(resetFieldid);
  //     settoggleValue(value);
  //     setcolumnName(columnName);
  //   }
  // }
  function handleAllChange(feildName, value) {
    fields.forEach((field) => {
      setValue(`update_supervisors.${field.position}.${feildName}`, value, {
        shouldDirty: true,
      });
    });
    if (feildName === "callmonitor") {
      setSelectedCallMonitor(value);
    } else if (feildName === "dynamicRecording") {
      setselectedRecording(value);
    } else {
      setselectDropDown(value);
    }
  }

  function handleUpdateToggle() {
    fields.forEach((field) => {
      setValue(
        `update_supervisors.${field.position}.${updateFieldName}`,
        updateFieldValue,
        {
          shouldDirty: true,
        }
      );
    });
    if (updateFieldName.indexOf("monitor") !== -1) setSelectedCallMonitor("-1");
    else if (updateFieldName.indexOf("Recording") !== -1)
      setselectedRecording("-1");
    else setselectDropDown("");

    warningToggle();
  }

  let processRows = [];
  // fields &&
  //   fields.length > 0 &&
  //   fields.forEach((info) => {
    if (fields && fields.length > 0 && filteredIndices.length > 0) {
        filteredIndices.forEach((originalIndex) => {
          const info = fields[originalIndex];
          
          // Additional safety check for the individual field object
          if (!info || typeof info !== 'object') return;       
      processRows.push({
        name: info.name,
        extension: info?.extension ?? "",
        monitor: (
          // <label className="switch">
          //   <input
          //     className="form-control"
          //     type="checkbox"
          //     checked={watch(`update_supervisors.${info.position}.callmonitor`)}
          //     onChange={(e) =>
          //       setValue(
          //         `update_supervisors.${info.position}.callmonitor`,
          //         e.target.checked,
          //         { shouldDirty: true }
          //       )
          //     }
          //   />
          //   <span className="slider round"></span>

          <div className="d-flex align-items-center justify-content-center">
            <label
              className={`big-checkbox ${watch(`update_supervisors.${info.position}.callmonitor`)
                ? "checked"
                : ""
                }`}
            >
              <input
                type="checkbox"
                checked={watch(
                  `update_supervisors.${info.position}.callmonitor`
                )}
                onChange={(e) =>
                  setValue(
                    `update_supervisors.${info.position}.callmonitor`,
                    e.target.checked,
                    { shouldDirty: true }
                  )
                }
              />
              <span className="box">
                <svg
                  className="checkmark"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </span>
            </label>
          </div>
        ),
        recording: (
          // <label className="switch">
          //   <input
          //     className="form-control"
          //     type="checkbox"
          //     checked={watch(
          //       `update_supervisors.${info.position}.dynamicRecording`
          //     )}
          //     onChange={(e) =>
          //       setValue(
          //         `update_supervisors.${info.position}.dynamicRecording`,
          //         e.target.checked,
          //         { shouldDirty: true }
          //       )
          //     }
          //   />
          //   <span className="slider round"></span>
          // </label>
          <div className="d-flex align-items-center justify-content-center">
            <label
              className={`big-checkbox ${watch(`update_supervisors.${info.position}.dynamicRecording`)
                ? "checked"
                : ""
                }`}
            >
              <input
                type="checkbox"
                checked={watch(
                  `update_supervisors.${info.position}.dynamicRecording`
                )}
                onChange={(e) =>
                  setValue(
                    `update_supervisors.${info.position}.dynamicRecording`,
                    e.target.checked,
                    { shouldDirty: true }
                  )
                }
              />
              <span className="box">
                <svg
                  className="checkmark"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </span>
            </label>
          </div>
        ),
        permissions: (  
              <select
                class="form-control form-select selectname w-100"
                value={watch(`update_supervisors.${info.position}.privilage`)}
                onChange={(e) => {
                  e.preventDefault();
                  setValue(
                    `update_supervisors.${info.position}.privilage`,
                    parseInt(e.target.value),
                    { shouldDirty: true }
                  );
                }}
              >
                {recordPermissions &&
                  recordPermissions.length > 0 &&
                  recordPermissions.map((option, index) => {
                    const keyid = Object.keys(option)[0];
                    const value = option[keyid];
                    return (
                      <option key={index} value={keyid}>
                        {value}
                      </option>
                    );
                  })}
              </select> 
        ),
        Delete: (
          <>
            <div className="ms-4 w-40">
              <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
                <MDBIcon
                  fas
                  icon="times"
                  color="primary"
                  title="Remove"
                  onClick={(e) => deleteSelectedUser(e, info)}
                />
              </div>
            </div>
          </>
        ),
      });
    });
  }
  const actionData1 = {
    columns: [
      {
        label: (
          <>
            <p className="fw-bold">Name</p>
            <p>All Members in List</p>
          </>
        ),
        field: "name",
      },
      {
        label: (
          <>
            <p className="fw-bold">Extension</p>
            <div>
              {" "}
              <p>&nbsp;</p>
            </div>
          </>
        ),
        field: "extension",
      },
      {
        label: (
          <>
            <p className="fw-bold text-center">Call Monitor</p>
            {/* <div class="three-checkbox round2 mx-0">
              <input
                type="radio"
                name={`monitor${supervisorFlag}`}
                id={`leftMonitor${supervisorFlag}`}
                checked={selectedCallMonitor === false}
                // value={`leftMonitor${supervisorFlag}`}
                onChange={(e) => {
                  if (e) {
                    setSelectedCallMonitor(false);
                    handleAllChange("callmonitor", "Call Monitor", false);
                  }
                }}
              />
              <input
                type="radio"
                checked={selectedCallMonitor === "-1"}
                name={`monitor${supervisorFlag}`}
                id={`middleMonitor${supervisorFlag}`}
                // value={`middleMonitor${supervisorFlag}`}
                onChange={(e) => {
                  if (e) {
                    setSelectedCallMonitor("-1");
                    handleAllChange("callmonitor", "Call Monitor", "-1");
                  }
                }}
              />
              <input
                type="radio"
                name={`monitor${supervisorFlag}`}
                id={`rightmonitor${supervisorFlag}`}
                checked={selectedCallMonitor === true}
                onChange={(e) => {
                  if (e) {
                    setSelectedCallMonitor(true);
                    handleAllChange("callmonitor", "Call Monitor", true);
                  }
                }}
              />
              <span class="slider"></span>
            </div> */}

            <div className="d-flex align-items-center justify-content-center">
              <label
                className={`big-checkbox ${selectedCallMonitor ? "checked" : ""
                  }`}
              >
                <input
                  type="checkbox"
                  checked={selectedCallMonitor}
                  onChange={(e) => {
                    if (e) {
                      // setSelectedCallMonitor(true);
                      handleAllChange("callmonitor", e.target.checked);
                    }
                  }}
                />
                <span className="box">
                  <svg
                    className="checkmark"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </span>
              </label>
            </div>
          </>
        ),
        field: "monitor",
        sort: false,
      },
      {
        label: (
          <>
            <p className="fw-bold text-center">Dynamic Recording</p>
            {/* <div class="three-checkbox round2 mx-0">
              <input
                type="radio"
                name={`Dy${supervisorFlag}`}
                id={`leftDy${supervisorFlag}`}
                // value={`leftDy${supervisorFlag}`}
                checked={selectedRecording === false}
                onChange={(e) => {
                  if (e) {
                    setselectedRecording(false);
                    handleAllChange(
                      "dynamicRecording",
                      "Dynamic Recording",
                      false
                    );
                  }
                }}
              />
              <input
                type="radio"
                name={`Dy${supervisorFlag}`}
                // defaultChecked
                id={`middleDy${supervisorFlag}`}
                // value={`middleDy${supervisorFlag}`}
                checked={selectedRecording === "-1"}
                onChange={(e) => {
                  if (e) {
                    setselectedRecording(-1);
                    handleAllChange(
                      "dynamicRecording",
                      "Dynamic Recording",
                      "-1"
                    );
                  }
                }}
              />
              <input
                type="radio"
                name={`Dy${supervisorFlag}`}
                // value={`rightDy${supervisorFlag}`}
                id={`rightDy${supervisorFlag}`}
                checked={selectedRecording === true}
                onChange={(e) => {
                  if (e) {
                    setselectedRecording(true);
                    handleAllChange(
                      "dynamicRecording",
                      "Dynamic Recording",
                      true
                    );
                  }
                }}
              />
              <span class="slider"></span>
            </div> */}

            <div className="d-flex align-items-center justify-content-center">
              <label
                className={`big-checkbox ${selectedRecording ? "checked" : ""}`}
              >
                <input
                  type="checkbox"
                  checked={selectedRecording}
                  onChange={(e) => {
                    if (e) {
                      // setselectedRecording(e.target.checked);
                      handleAllChange("dynamicRecording", e.target.checked);
                    }
                  }}
                />
                <span className="box">
                  <svg
                    className="checkmark"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                      fill="#FFFFFF"
                    />
                  </svg>
                </span>
              </label>
            </div>

            {/* <MDBCheckbox />  */}
          </>
        ),
        field: "recording",
        sort: false,
      },
      {
        label: (
          <>
            <p className="fw-bold" style={{whiteSpace:"normal"}}>Recording Listening Permissions</p>  
                <select
                  id={`privilage${supervisorFlag}`}
                  class="form-control form-select selectname w-100"
                  value={selectDropDown}
                  onChange={(e) => {
                    if (e && e?.target?.value) {
                      // setselectDropDown(e?.target?.value);
                      if (e?.target?.value !== "") {
                        handleAllChange(
                          "privilage",
                          // "Recording Listening Permissions",
                          parseInt(e.target.value)
                        );
                      }
                    }
                  }}
                >
                  <option value="">--Select Record Permission--</option>
                  {recordPermissions &&
                    recordPermissions.length > 0 &&
                    recordPermissions.map((option, index) => {
                      const keyid = Object.keys(option)[0];
                      const value = option[keyid];
                      return (
                        <option key={index} value={keyid}>
                          {value}
                        </option>
                      );
                    })}
                </select> 
          </>
        ),
        field: "permissions",
        sort: false,
      },
      {
        // label:
        // (
        //   <>
        //     <p className="fw-bold">Remove</p>
        //     <div className="ms-4 w-40">
        //       <div className="custom-hover-bg p-1 px-2 cursor-pointer deleteToolTip">
        //         <MDBIcon fas icon="times" color="primary" title="Remove" />
        //       </div>
        //     </div>
        //   </>
        // ),
        label: (
          <>
            <p className="fw-bold">Remove</p>
            <div> 
              <p>&nbsp;</p>
            </div>
          </>
        ),

        field: "Delete",
        sort: false,
      },
    ],
    rows: processRows,
  };

  async function onSaveChanges(data) {
    if (isDirty) {
      const dirtyFieldsArray = dirtyFields["update_supervisors"];
      const dataFieldsArray = data["update_supervisors"];
      const modifiedRows = [];
      console.log(
        "value inner ::::::::::::: " + JSON.stringify(dirtyFieldsArray)
      );
      console.log(
        "value inner data::::::::::::: " + JSON.stringify(dataFieldsArray)
      );

      if (dirtyFieldsArray) {
        for (let i = 0; i < dirtyFieldsArray.length; i++) {
          console.log(dirtyFieldsArray[i]);
          if (!dirtyFieldsArray[i]) {
            continue;
          }
          const modifiedFields = {};
          const dirtyFieldNames = dirtyFieldsArray[i];
          Object.entries(dirtyFieldNames).map(([key, value]) => {
            if (data.update_supervisors[i]?.hasOwnProperty(key)) {
              modifiedFields[key] = data.update_supervisors[i][key];
            }
          });
          if (Object.keys(modifiedFields).length > 0) {
            modifiedFields.agentId = data.update_supervisors[i].uniqueid;
            // modifiedFields.position = data.update_supervisors[i].position;
            modifiedRows.push(modifiedFields);
          }
        }
      }

      console.log("value is ::::::::::: " + JSON.stringify(modifiedRows));

      // alert("final value is ::::::::::: " + JSON.stringify(result));
      if (modifiedRows.length > 0) {
        const updateObj = {
          reqid: 9,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          code: code,
          huntsupervisorsettings: {
            update_supervisors: modifiedRows,
          },
        };

        console.log("final value is ::::::::::: " + JSON.stringify(updateObj));

        setIsloading(true);

        let saverep = await editHuntGroup(updateObj);
        setIsloading(false);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        console.log(
          "reponse from supervisor hunt group ::::::::::: " +
          JSON.stringify(saverepeMsg)
        );

        if (saverepeMsg.status && saverepeMsg.status == "success") {
          setSuccessMessage(saverepeMsg.message);
          setReRender(true);
        } else {
          if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
            });
          }
        }
      }
    }
  }

  const isSave = Object.keys(dirtyFields).length > 0 ? true : false;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave]);

  const onCloseChanges = () => {
    // processUserDtlsFraming(alreadyExistedUsersAndPhnum);
    setselectDropDown("");
    setselectedRecording("-1");
    setSelectedCallMonitor("-1");
    setReRender(true);
  };

  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      updateTheUser(
        supervisorFlag === 2 ? "add_non_group_supervisors" : "add_superviors"
      );
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  useEffect(() => {
    if (updateUsers.length > 0 && isdeleteUser) {
      let isNonMember = false;
      if (supervisorFlag === 3) {
        isNonMember = updateUsers[0]?.ismember === 0 ? true : false;
      } else if (supervisorFlag === 2) {
        isNonMember = true;
      }
      updateTheUser(
        isNonMember ? "remove_non_group_supervisors" : "remove_supervisors"
      );
      setIsDeleteUser(false);
    }
  }, [updateUsers, isdeleteUser]);

  async function updateTheUser(fieldName) {
    const agentids = new Set(
      updateUsers.map((item) => item?.agentid || item?.uniqueid)
    );
    let update = {
      reqid: 9,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: code,
      huntsupervisorsettings: {
        [fieldName]: Array.from(agentids),
      },
    };
    console.log(JSON.stringify(update));
    setIsloading(true);
    let saverep = await editHuntGroup(update);
    setIsloading(false);

    console.log(saverep);
    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      setSuccessMessage(saverepeMsg.message);
      setReRender(true);
    } else {
    }
  }

  function deleteSelectedUser(event, usrObj) {
    event.preventDefault();
    event.stopPropagation();
    setUpdateUsers([usrObj]);
    dtogglePopup();
  }

const handleSearch = (value) => {
  setSearchValue(value); 

  if (!fields || fields.length === 0) {
    setFilteredIndices([]);
    return;
  }
  
  if (!value.trim()) {
    setFilteredIndices(fields.map((_, index) => index));
    return;
  }
  
  const filterResult = customSearch(fields, value, ["name", "extension"]);
  
  const matchingIndices = filterResult.map(filteredItem => 
    fields.findIndex(field => 
      field && ( // Add safety check for field existence
        field.id === filteredItem.id || 
        (field.name === filteredItem.name && field.extension === filteredItem.extension)
      )
    )
  ).filter(index => index !== -1);
  
  setFilteredIndices(matchingIndices);
};

  return (
    <>
      <div className="actionbar">
        {supervisorFlag !== 3 && (
          <MDBBtn
            className="btn btn-primary green-button display-inline float-right me-2"
            onClick={addTogglePopup}
          >
            <MDBIcon fas icon="plus" size="sm" /> {t("Add Supervisor")}
          </MDBBtn>
        )}
      </div>

      {supervisorList && (
                    <div style={{ width: "306px" }}>
                        <MDBInputGroup className="w-100" textAfter={<MDBIcon fas icon="search" />}>
                            <input
                                type="text"
                                className="form-control w-100"
                                placeholder="Search"
                                ref={searchRef}
                                value={searchValue}
                                onChange={(e) => {
                                    // setSearchInput(e.target.value);
                                    handleSearch(e.target.value);
                                }}
                            />
                        </MDBInputGroup>
                    </div>
                )}


      <div className="hunt-accTable">
        <MDBDatatable
          // search
          sortField="Name"
             key={searchValue}
          entries={50}
          data={actionData1}
          className="mt-2 actioncolumn top-15Icon"
        />
      </div>   
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {isSave && (
        <SaveChanges
          onClose={onCloseChanges}
          onSave={(e) => {
            e.preventDefault();
            handleSubmit(onSaveChanges)();
          }}
        />
      )}
      {addUsers && (
        <PopupLoaderNew
          title={t("Add Supervisor")}
          content={
            <AddToUsers
              onClose={addTogglePopup}
              selectedUsers={supervisorList}
              setUpdateUsers={setUpdateUsers}
              setIsAddedUsers={setIsAddedUsers}
              sourceUsers={sourceUsers}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setAddUsers}
          onClose={addTogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={2}
        />
      )}
      {isdelete && (
        <PopupLoaderNew
          title={"Remove Supervisor"}
          content={
            <RemoveToUser
              setIsDeleteUser={setIsDeleteUser}
              onClose={dtogglePopup}
              ref={addUserRef}
              setIsloading={setisLoading}
              supervisorFlag={true}
            />
          }
          onShow={setIsDelete}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={
                updateFieldName.indexOf("privilage") === -1 ? toggleValue : null
              }
              columnName={columnName}
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}
      {successMessage && (
        <>
          <TopSuccess>
            <TopMessage successMessage={successMessage} />
          </TopSuccess>
        </>
      )}
    </>
  );
}

export default HuntSupervisorBody;
